import { finalize } from "rxjs/operators";
import { Component } from "@angular/core";

import { TradableListService } from "../../services/currency/tradable_list.service";
import { TradableWalletListService } from "../../services/wallet/tradable_wallet_list.service";
import { Helper } from "@helpers/functions";
import { Tradable } from "@models/interfaces/tradable";
import { TradableWallet } from "@models/interfaces/tradable_wallet";
import { BpModalHasSave } from "@models/interfaces/bp-modal-has-save";
import { Index } from "@models/asset/index/index.model";
import { ApicallService } from "@core-services/apicall.service";
import { CustomModal } from "../../../core/components/base-modals";
import { InfoService } from "@core-services/info.service";
import { BpSelectOption } from "@modules/core/components/bp-select/bp-select.component";

@Component({
	templateUrl: "./wallet-modal.component.html",
	styleUrls: ["./wallet-modal.component.scss"],
	standalone: false
})
export class WalletModalComponent extends CustomModal implements BpModalHasSave {
	public operationInProgress = false;
	public walletName: string = "";

	public constructor(
		private apicallService: ApicallService,
		private infoService: InfoService,
		private tradableListService: TradableListService,
		private tradableWalletListService: TradableWalletListService
	) {
		super();
	}

	public save(): void {
		if (!this.operationInProgress) {
			this.operationInProgress = true;
			const wallets = this.tradableWalletListService.getWalletsByTradableId(this.data.getCurrencyId());
			const service = this.tradableWalletListService.serviceForObject(wallets[0]);

			service
				.createNewWallet(this.data)
				.pipe(finalize(() => (this.operationInProgress = false)))
				.subscribe(
					(w: TradableWallet[]) => {
						service.upsert(w[0]);
						this.infoService.setSuccess(
							this.translationService.translate("info_text_modal_wallet_new_wallet_created")
						);
						this.close();
					},
					(error) => {
						Helper.handleError(error, this.data);
						this.infoService.setError(error);
						this.close();
					}
				);
		}
	}

	public updatePrefillName(): void {
		this.data.name =
			this.tradable.getSymbol(false, true) +
			" Wallet " +
			(this.tradableWalletListService.getWalletsByTradableId(this.tradable.getId()).length + 1);
		this.walletName = this.data.name;
	}

	public get tradable(): Tradable {
		return this.tradableListService.getItemById(this.data.getCurrencyId());
	}

	public set tradable(c: Tradable) {
		this.data.setCurrencyId(c.getId());
	}

	public tradableOptions: BpSelectOption[] = this.tradableListService.list
		.filter((tradable) => !(tradable instanceof Index) && !tradable.isIndexOnly())
		.map((tradable) => ({
			name: tradable.getName(),
			icon: tradable.getIconCssName(true),
			value: tradable
		}));

	public get name(): string {
		return this.data.name;
	}

	public updateOnEmpty(s: string): void {
		if (s.length <= 0) {
			this.data.name = s;
		}
	}

	public set name(s: string) {
		if (this.data.name.length <= 0) {
			this.updatePrefillName();
		} else {
			this.data.name = s;
		}
	}

	public get error(): string {
		return this.data.hasError("cryptocoin_id") ? this.data.getValidationError("cryptocoin_id") : null;
	}
}
